import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { normalizeChannelHandle } from '@jwp/ott-common/src/utils/channelHandle';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import SuccessCircleIcon from '@jwp/ott-theme/assets/icons/success_circle.svg?react';

import Button from '../Button/Button';

import styles from '../ChannelCreatedModal/ChannelCreatedModal.module.scss';

type LocationState = {
  channelHandle?: string;
};

const EditChannelSuccessModal = () => {
  const { t } = useTranslation('user');
  const navigate = useNavigate();
  const location = useLocation();
  const myChannelHandle = useAccountStore((state) => state.myChannelHandle);
  const channelHandle = normalizeChannelHandle(
    (location.state as LocationState | null)?.channelHandle || myChannelHandle || '',
  );

  const onClose = () => {
    if (channelHandle) {
      navigate(`/channel/${channelHandle}`, { replace: true });
      return;
    }

    navigate(-1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.iconWrap} aria-hidden="true">
        <SuccessCircleIcon className={styles.successIcon} />
      </div>
      <h2 className={styles.title}>{t('edit_channel.success_title')}</h2>
      <p className={styles.description}>{t('edit_channel.success_description')}</p>
      <div className={styles.actions}>
        <Button
          label={t('edit_channel.okay_button')}
          variant="contained"
          color="primary"
          onClick={onClose}
          className={styles.viewChannel}
        />
      </div>
    </div>
  );
};

export default EditChannelSuccessModal;